import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay"]

  toggle() {
    this.overlayTarget.hidden = !this.overlayTarget.hidden
  }
}
